import axios from "axios";
import { logoutUser } from "../keycloak/keyCloakConfig";
import config from "../config/index";

const redirectUri = config.redirectUri;

export { redirectUri };
export const instanceCS = axios.create({
  baseURL: config.contentApiEndPoint,
  timeout: 75000,
});
export const nodeInstanceCS = axios.create({
  baseURL: config.nodeContentApiEndPoint,
  timeout: 75000,
});

instanceCS.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // Check if the error response exists
    if (error.response) {
      const { status } = error.response;

      if (status === 401 || status === 403) {
        if (true) {
          setTimeout(() => {
            logoutUser();
          }, 2000);
        }
      }
    }

    return Promise.reject(error);
  },
);
nodeInstanceCS.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // Check if the error response exists
    if (error.response) {
      const { status } = error.response;

      if (status === 401 || status === 403) {
        if (true) {
          setTimeout(() => {
            logoutUser();
          }, 2000);
        }
      }
    }

    return Promise.reject(error);
  },
);

// Add a request interceptor
instanceCS.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    //  const token = "12345678dkdklsdf";
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

nodeInstanceCS.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    //  const token = "12345678dkdklsdf";
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Add a response interceptor
instanceCS.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

nodeInstanceCS.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export const instanceCSStorage = axios.create({
  baseURL: config.storageApiEndPoint,
  timeout: 8000,
  // headers: { "X-Custom-Header": "foobar" },
});

// Add a request interceptor
instanceCSStorage.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    //  const token = "12345678dkdklsdf";
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Add a response interceptor
instanceCSStorage.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export const instanceCSUpload = axios.create({
  baseURL: config.contentApiEndPoint,
  timeout: 60 * 4 * 1000,
});
//testing
// Add a request interceptor
instanceCSUpload.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    //  const token = "12345678dkdklsdf";
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Add a response interceptor
instanceCSStorage.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// export default instanceCS;

export default { nodeInstanceCS, instanceCS };
